
module.exports = {
  statusColors () {
    return {A: '#B0C4DE', B: '#ffcc80', C: '#228B22', D: '#2196f3', E: '#AA1111'}
  },
  salutationList () {
    return ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Hon', 'Prof']
  },
  relationList () {
    return [
      'Husband', 'Wife', 'Father', 'Mother', 'Son',
      'Daughter', 'Cousin', 'Brother', 'Sister',
      'Uncle', 'Nephew', 'Niece', 'Mother-in-law', 'Sister-in-law', 'Brother-in-law']
  },
  religionList () {
    return [
      'Christian',
      'Muslim',
      'Hindu',
      'Buddist',
      'Jewish',
      'Sikh'
    ]
  },
  denominationList () {
    return [
      'Anglican',
      'Evangelical',
      'SDA',
      'WatchTower',
      'Protestant',
      'Catholic',
      'Orthodox',
      'Reform',
      'Sunni Muslim',
      'Shia Muslim',
      'Jewish'
      ]
  },
  monthList () {
    return [
      {text: 'Jan', value: 1}, {text: 'Feb', value: 2}, {text: 'Mar', value: 3},
      {text: 'Apr', value: 4}, {text: 'May', value: 5}, {text: 'Jun', value: 6},
      {text: 'Jul', value: 7}, {text: 'Aug', value: 8}, {text: 'Sep', value: 9},
      {text: 'Oct', value: 10}, {text: 'Nov', value: 11}, {text: 'Dec', value: 12}]
  },
  countryList () {
    return [
      'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda',
      'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh',
      'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina',
      'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia',
      'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands',
      'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti',
      'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia',
      'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon',
      'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala',
      'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India',
      'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan',
      'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya',
      'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives',
      'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat',
      'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand',
      'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay',
      'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda',
      'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia',
      'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain',
      'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland',
      'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', "Timor L'Este", 'Togo', 'Tonga',
      'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine',
      'United Arab Emirates', 'United Kingdom', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)',
      'Yemen', 'Zambia', 'Zimbabwe']
  }
}
